import React from 'react';
import PropTypes from 'prop-types';
import useTitle from '../../../Title/hooks/useTitle';
import { Popover } from 'antd';
import './titleMentionPopover.less';
import LoadingSpinner from '../../../UI/LoadingSpinner';

TitleMentionPopover.propTypes = {
	parsedIsbn: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	placement: PropTypes.string,
};

TitleMentionPopover.defaultProps = {
	placement: 'top',
};

export default function TitleMentionPopover({
	children,
	parsedIsbn,
	placement,
}) {
	const { title, isLoading, getJacketCoverImage } = useTitle(
		parsedIsbn,
		true,
	);
	const jacketCoverImage = getJacketCoverImage();
	const jacketCoverImageUri =
		jacketCoverImage && `${jacketCoverImage.uri}?height=200`;

	const renderPopoverContent = () => {
		const productDetailKeys = ['name', 'author', 'supplier', 'sku'];
		return (
			<>
				{jacketCoverImageUri && (
					<img
						alt="Title jacket cover"
						className="jacket-cover-image"
						src={jacketCoverImageUri}
					/>
				)}
				<div className="title-details">
					{productDetailKeys.map(
						key =>
							title[key] && (
								<p key={key} className={`category-type ${key}`}>
									{title[key]}
								</p>
							),
					)}
				</div>
			</>
		);
	};

	return (
		<Popover
			placement={placement}
			content={isLoading ? <LoadingSpinner /> : renderPopoverContent()}
			overlayClassName="title-mention-popover">
			{children}
		</Popover>
	);
}
